import React from 'react';

const CheckedSvg = fill => (
  <svg
    width="18"
    height="14"
    viewBox="0 0 18 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.00016 11.1698L1.83016 6.99984L0.410156 8.40984L6.00016 13.9998L18.0002 1.99984L16.5902 0.589844L6.00016 11.1698Z"
      fill={fill}
    />
  </svg>
);

export default CheckedSvg;



// WEBPACK FOOTER //
// ./src/images/svg_js/CheckedSvg.js